if(typeof p80 === typeof undefined) {
    var p80 = {};
}
//
p80.productRecommendations = function(config) {
    /****
     *
     * USAGE:
     * 
     * Update line 51 with your unique store front access token (if it is not initialized as part of our theme)
     * 
     * const p80ProductRecommendations = new p80.productRecommendations(
     *  {
     *      resultsDisplayed: 4,
     *      targetElement: "your-target-identifier"
     *      title: "You may also like"
     *      productIds: 15442113|12521231|1231232131|552512512
     *  }
     * );
     * 
     * REFRESH LIVE:
     * 
     * p80Productrecommendations.getRecommendations();
     * 
    */


    /****
     * 
     * CONFIGURATION
     * 
     * {
     *      resultsDisplayed: int || 4,
     *      targetElement: string || "product-recommendations",
     *      title: string || "You may also like",
     *      productIds: string || '',
     * }
     * 
    */
    
    this.config = {};
    // Maxmium number of recently viewed products displayed
    this.config.resultsDisplayed = config && config.resultsDisplayed ? config.resultsDisplayed : 4;
    // String that holds the title for our recently viewed product area
    this.config.title = config && config.title ? config.title : "",
    // The string identifier for the element we will look to append our markup to
    this.config.targetElement = config && config.targetElement ? config.targetElement : "product-recommendations-wrapper";
    // The product IDs in our recommendation metafield
    this.config.productIds = config && config.productIds ? config.productIds : '';
    // Our unique store front access token
    this.config.storefrontToken = 'd5c34a807a585af172dd7bfd48f7746c';

    this.loader = document.getElementById("product-recommendations__loader");
    //get products wrapper element or slider list element
    this.productsWrapper = this.findTargetElement();
    /****
     * 
     * Data
     * 
    */

    // Holds our product recommendations
    this.productRecommendations = null;
    // Holds our markup
    this.html = null;
    // Fetch our product recommendations and generate Results
    if(!this.config.productIds) {
        console.error("No product IDs passed");
        return;
    }
    this.getRecommendations();
}
// Get our product recommendations
p80.productRecommendations.prototype.getRecommendations = function() {
    let recommendations = this;
    // Display our loader
    if(recommendations.loader) {
        recommendations.loader.classList.add("visible");
    }
    // Change our pipe delimited string to an array
    const products = recommendations.config.productIds.split("|");

    // Generate our graphql query to get each products's information
    let productIds = '';
    for (let i = 0; i < this.config.resultsDisplayed; i++) {
        productIds += `"gid://shopify/Product/${products[i]}",`
    };
    const graphQuery = `
    {nodes(ids: [${productIds}]){
        ... on Product {
            id
            title
            onlineStoreUrl
            handle
            variants(first: 1){
                edges {
                    node {
                        compareAtPrice
                        price
                        availableForSale
                    }
                }
            }
            media(first: 2) {
                edges {
                    node {
                        mediaContentType
                        alt
                        ...on MediaImage {
                            image {
                                originalSrc
                                large: transformedSrc(maxWidth: 720)
                                small: transformedSrc(maxWidth: 360)
                            }
                        }
                    }
                }
            }
            tags
            priceRange {
            maxVariantPrice {
                amount
            }
            minVariantPrice {
                amount
            }
            }
        }
        }
    }`;

    // Make sure we have products - if not, don't bother making our call
    if(!productIds) {
        return;
    }

    fetch("/api/2021-10/graphql.json", {
        method: "POST", 
        headers: {
            "X-Shopify-Storefront-Access-Token": recommendations.config.storefrontToken,
            "Content-Type": "application/graphql",
        },
        body: graphQuery
    })
    .then(response => response.json())
    .then(data => {
        if(data.data) {
            recommendations.productRecommendations = data.data.nodes;
            // Filter out null returns
          	recommendations.productRecommendations = recommendations.productRecommendations.filter(function (el) {
                return el != null;
            });
            recommendations.generate();
        }
    })
    .catch(error => {
        console.error(error)
    });
}
// Generate our markup
p80.productRecommendations.prototype.generate = function () {
    const recommendations = this;

    let productListItems = Array.from(this.productsWrapper.querySelectorAll("li"));

    let card_product_template = document.getElementById("card_product_template");
    
    // Loop through our recommendations products
    for(var i = 0; i<recommendations.productRecommendations.length; i++) {
        var card_product_temp_clone = card_product_template.content.cloneNode(true);

        let product = recommendations.productRecommendations[i];
        // get title/link element
        let productEl = card_product_temp_clone.querySelector(".card__heading a");
        productEl.setAttribute("title", product.title);
        productEl.href = `/products/${product.handle}`;
        productEl.innerHTML = product.title;

        //media
        let media_wrapper = card_product_temp_clone.querySelector(".media")
        // Create our product image if it exists
        let productImage; 
        //zoom image on product image hover
        let zoomImage;
        if(recommendations.productRecommendations[i].media.edges.length > 0) {
            productImage = this.generateImage(recommendations.productRecommendations[i],0);
            zoomImage = this.generateImage(recommendations.productRecommendations[i],1);
        }
        else {
            productImage = document.createElement("div");
            productImage.classList.add("product-recommendations__image--placeholder");
        }
        
        // Append the image to our wrapper
        if (productImage) {
            media_wrapper.appendChild(productImage);
            if (zoomImage) {
            media_wrapper.appendChild(zoomImage);
            }
        }
       
        let variant = recommendations.productRecommendations[i].variants.edges[0].node;
        let price = variant.price;
        let compareAtPrice = variant.compareAtPrice;
        if(price) {
          price = parseFloat(price).toFixed(2);
        }
        if(compareAtPrice) {
          compareAtPrice = parseFloat(compareAtPrice).toFixed(2);
        }

        //price wrapper
        let priceWrapper = card_product_temp_clone.querySelector(".price");
        //regular price
        let regularPriceContainer = card_product_temp_clone.querySelector(".price-item--regular");

        //sale price
        let salePriceContainer = card_product_temp_clone.querySelector(".price-item--sale")
        let salePriceCompareContainer = card_product_temp_clone.querySelector(".price__sale .price-item--regular");

        // dont display 0 price
        if(price > 0)
        {
            if(price === compareAtPrice) {
                regularPriceContainer.innerHTML = `$ ${price}`;
            }
            // Product has two different prices - show price range
            else {
                priceWrapper.classList.add("price--on-sale");
                salePriceContainer.innerHTML = `$ ${price} - `;
                salePriceCompareContainer.innerHTML = `$ ${compareAtPrice}`;
            }
        }

        //set badges
        let badge = card_product_temp_clone.querySelector(".badge");
        // if out of stock
        if (!variant.availableForSale) {
            badge.classList.add("badge--out-of-stock");
            badge.innerHTML = "OUT OF STOCK"
        }
        // if sale
        else if(price < compareAtPrice){
            badge.classList.add("badge--sale");
            badge.innerHTML = "SALE"
        }
        // if new product
        else if(product.tags.includes("new")){
            badge.classList.add("badge--new");
            badge.innerHTML = "NEW"
        }
        // if best seller
        else if(product.tags.includes("best-seller")){
            badge.classList.add("badge--best-seller");
            badge.innerHTML = "BEST SELLER"
        }

        productListItems[i].appendChild(card_product_temp_clone);
    }

    recommendations.removeLoader();
}

//generate image
p80.productRecommendations.prototype.generateImage = function(product, index){
    //if media on index does not exists or media is not of type IMAGE
    if(!product.media.edges[index] || product.media.edges[index].node.mediaContentType != "IMAGE") 
        return null;
    let productImage = document.createElement("img");
            const imageUrls = product.media.edges[index].node.image;
            let srcSet = '';
            let imageSizes = '';
            let originalSrc = '';
            for (const url in imageUrls) {
                if(url === "small") {
                    srcSet += `${imageUrls[url]} 360w,`
                    imageSizes += '(max-width: 767px) 360px, ';
                }
                else if(url === "large") {
                    srcSet += `${imageUrls[url]} 720w,`
                    imageSizes += '(min-width: 768px) 720px, '
                }
                else if(url === "originalSrc") {
                    originalSrc = imageUrls[url];
                }
            }
            productImage.setAttribute("loading", "lazy");
            productImage.setAttribute("srcset", srcSet);
            productImage.setAttribute("sizes", imageSizes);
            productImage.src = originalSrc;
            productImage.alt = product.title;
            productImage.setAttribute("class", "motion-reduce product-recommendations__image");
        return productImage;
}

// remove loader
p80.productRecommendations.prototype.removeLoader = function() {
    const recommendations = this;
    // hide our loader
    if(recommendations.loader) {
        recommendations.loader.classList.remove("visible");
    }
}
// Helper function to find our target element for appending markup
p80.productRecommendations.prototype.findTargetElement = function() {

    /****
     * 
     * Target Finding priority:
     * 
     * ID
     * Class - Taking first result
     * Data Attributes - Taking first result
     * 
    */

    // Find by ID
    let target = document.getElementById(this.config.targetElement);
    // Find by Class
    if(!target) {
        target = document.getElementsByClassName(this.config.targetElement);
        if(target) {
            target = target[0];
        }
    }
    // Find by Attribute
    if(!target) {
        target = document.querySelector(`[${this.config.targetElement}]`);
    }

    // Return our target if found
    return target ? target : null;
}